import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Menu, Icon } from "semantic-ui-react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import swal from "sweetalert";
import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  LinkRedirect,
  SemanticButton,
  Mail,
} from "./styled";
import "react-toastify/dist/ReactToastify.css";
import { systemLogs } from "../../../services/system_logs";
import ModalTransfer from "./Modal";

function TransferirConta() {
  const [alunos, setAlunos] = useState([]);
  const [totalAlunos, setTotalAlunos] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [search, setSearch] = useState("");

  const listarAlunos = useCallback(
    async (page = 1) => {
      try {
        const params = {
          page,
        };

        if (search) {
          params.search = search;
        }

        const response = await api.get("alunos", { params });

        await systemLogs("alunos", `listou os alunos da paginab${page}`);

        const alunos = response.data;

        const xTotal = response.headers["x-total-count"];
        const totalPaginas = Math.round(xTotal / 50);

        if (!alunos || !alunos.length) {
          throw new Error("Sem alunos");
        }

        setPage(page);
        setAlunos(alunos);
        setTotalPage(totalPaginas);
      } catch (err) {
        console.error(err);

        setPage(1);
        setAlunos([]);
        setTotalPage(0);
      }
    },
    [search]
  );

  

  const nextPage = useCallback(() => {
    if (page === totalPage) return;

    const pageNumber = page + 1;

    listarAlunos(pageNumber);
  }, [page, totalPage, listarAlunos]);

  const previousPage = useCallback(() => {
    if (page === 1) return;

    const pageNumber = page - 1;

    listarAlunos(pageNumber);
  }, [page, listarAlunos]);

  useEffect(() => {
    listarAlunos();
  }, []);

  return (
    <div style={{width: "100vw", padding:" 0 1rem 0 calc(250px + 1rem)"}}>

      <AdminMenu />

      <Container>
        <Title>Transferir conta dos Alunos</Title>

        <ContainerInputSearch className="ui fluid left icon input">
          <Input
            type="search"
            placeholder="Digite o nome do aluno ou do e-mail e pressione ENTER"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyUp={(e) => e.key === "Enter" && listarAlunos()}
          />
          <Icon name="search icon" onClick={listarAlunos} />
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
            <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>e-mail</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações </SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body>
            {alunos.map((aluno) => (
              <SemanticTable.Row>
                <SemanticTable.Cell>{aluno.id}</SemanticTable.Cell>
                <SemanticTable.Cell> {aluno.nome} </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {aluno.email}
                  <Mail name="mail square icon" />
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                    <ModalTransfer email={aluno.email}/>
                </SemanticTable.Cell>
              </SemanticTable.Row>
            ))}
          </SemanticTable.Body>

          <SemanticTable.Footer>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell colSpan="4">
                <Menu floated="right" pagination>
                  <Menu.Item as="a" icon onClick={previousPage}>
                    <Icon name="chevron left" />
                  </Menu.Item>
                  <Menu.Item as="a" icon onClick={nextPage}>
                    <Icon name="chevron right" />
                  </Menu.Item>
                </Menu>
              </SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Footer>
        </SemanticTable>
      </Container>
    </div>
  );
}

export default TransferirConta;
